import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { ATTENDANCE_ROUTE, HRX_ATTENDANCE_ROUTE } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, PUT, POST } = HTTP_METHODS;
const { GET_ATTENDANCE } = ATTENDANCE_ROUTE;
const { GET_HRX_ATTENDANCE, ATTENDANCE_TIME_LOG } = HRX_ATTENDANCE_ROUTE;

export const attendanceApi = createApi({
  reducerPath: 'attendance',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getActivity: builder.query({
      query: (data) => ({
        url: `${GET_ATTENDANCE}/get-activity-work-log${buildQueryString(data)}`,
        method: GET
      })
    }),
    syncTimeDoctorUserIds: builder.mutation({
      query: () => ({
        url: `${GET_ATTENDANCE}/sync-user-ids`,
        method: POST
      })
    }),
    getTotalTime: builder.query({
      query: (data) => ({
        url: `${GET_ATTENDANCE}/get-timesheet-work-life${buildQueryString(data)}`,
        method: GET
      })
    }),
    getAttendanceApprovalList: builder.query({
      query: (data) => ({
        url: `${GET_ATTENDANCE}/get-attendance-approval-list${buildQueryString(data)}`,
        method: GET
      })
    }),
    editAssets: builder.mutation({
      query: (data) => ({
        url: `${ASSETS}/${data?.id}`,
        method: PUT,
        data: data?.data
      })
    }),
    updateAttendanceApprovalList: builder.mutation({
      query: (data) => ({
        url: `${GET_ATTENDANCE}/get-attendance-approval-list/${data?.id}`,
        method: PUT,
        data: data?.data
      })
    }),
    getAttendanceTimeLog: builder.query({
      query: (params) => ({
        url: ATTENDANCE_TIME_LOG,
        method: GET,
        params
      })
    }),
    getHRXAttendanceOverview: builder.query({
      query: (data) => ({
        url: `${GET_HRX_ATTENDANCE}/overview${buildQueryString(data)}`,
        method: GET
      })
    }),
    getHRXAttendanceList: builder.query({
      query: (data) => ({
        url: `${GET_HRX_ATTENDANCE}/list${buildQueryString(data)}`,
        method: GET
      })
    }),
    getHRXAttendanceById: builder.query({
      query: (data) => ({
        url: `${GET_HRX_ATTENDANCE}/${data?.id}`,
        method: GET
      })
    }),
    updateWorkSession: builder.mutation({
      query: (data) => ({
        url: `${GET_HRX_ATTENDANCE}/update-work-session/${data?.id}`,
        method: PUT,
        data: data?.data
      })
    }),
    updateBreakSession: builder.mutation({
      query: (data) => ({
        url: `${GET_HRX_ATTENDANCE}/update-break-session/${data?.id}`,
        method: PUT,
        data: data?.data
      })
    })
  })
});

export const {
  useGetActivityQuery,
  useSyncTimeDoctorUserIdsMutation,
  useGetTotalTimeQuery,
  useGetAttendanceApprovalListQuery,
  useGetAttendanceTimeLogQuery,
  useGetHRXAttendanceOverviewQuery,
  useGetHRXAttendanceListQuery,
  useGetHRXAttendanceByIdQuery,
  useUpdateAttendanceApprovalListMutation,
  useUpdateWorkSessionMutation,
  useUpdateBreakSessionMutation
} = attendanceApi;
